import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button, ButtonType } from '../Button';

export interface NotificationBannerProps {
  icon: IconProp;
  title: string;
  body: string | JSX.Element;
  color: string;
  onClick?: () => void;
  buttonTitle?: string;
}

export const NotificationBanner = ({ icon, title, body, color, onClick, buttonTitle }: NotificationBannerProps): JSX.Element => (
    <div className='flex flex-col items-start p-4 border-2 rounded-2xl text-almostBlack mb-10' style={{ borderColor: color }}>
      <div
        className='mr-4 rounded-full border-2 w-9 h-9 flex items-center justify-center'
        // lighten the passed in color by 80%
        style={{ borderColor: `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, 0.2)` }}
      >
        <FontAwesomeIcon icon={icon} style={{ color }} />
      </div>
      <div className='flex-grow'>
        <h4 className='font-extrabold pt-2'>{title}</h4>
        <p className='text-sm font-light pt-2 pb-2'>{body}</p>
        {buttonTitle && onClick && (
          <Button
            onClick={onClick}
            buttonType={ButtonType.primary}
            className='mt-2 text-sm font-light'
          >
            {buttonTitle}
          </Button>
        )}
      </div>
    </div>
  );
